type RecordType = Record<string, unknown>;

export function deepMerge (target: RecordType, ...sources: RecordType[]): RecordType {
  if (!sources.length) {
    return target;
  }
  const source = sources.shift();

  if (isObject(target) && isObject(source)) {
    for (const key in source) {
      if (isObject(source[key])) {
        if (!target[key]) {
          Object.assign(target, { [key]: {} });
        }
        deepMerge(target[key] as RecordType, source[key] as RecordType);
      } else {
        Object.assign(target, { [key]: source[key] });
      }
    }
  }

  return deepMerge(target, ...sources);
}

function isObject (item: unknown): item is RecordType {
  return Boolean(item && typeof item === 'object' && !Array.isArray(item));
}
